import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import MainLayout from './layouts/mainLayout';
import LoginLayout from './layouts/loginLayout';
import ProtectedRoute from './components/authentication/protectedRoute'; // Import ProtectedRoute

import LoginPage from './pages/Login.js';
import Dashboard from './pages/dashboard/router';
import Properties from './pages/Properties.js';
import Portfolio from './pages/Portfolio.js';
import BalanceTransactions from './pages/balanceTransactions/router';
import ManageVendors from './pages/ManageVendors.js';
import ManageInvoiceCategories from './pages/ManageInvoiceCategories.js';
import RequestsRouter from './pages/requests/router';
import Parcels from './pages/parcels/MParcels.js';
import Visitors from './pages/visitors/MVisitors.js';
import ParcelsVisitors from './pages/ParcelsVisitors.js';
import Management from './pages/people/Management.js';
import Owners from './pages/people/Owners.js'
import Tenants from './pages/people/Tenants.js'
import Announcements from './pages/announcements/router';
import ChatPage from './pages/EllieAI.js';

const AppRoutes = () => {
    return (
        <Router>
            <Routes>
                {/* Login Layout Routes */}
                <Route
                    path="/"
                    element={
                        <LoginLayout>
                            <LoginPage />
                        </LoginLayout>
                    }
                />
                <Route
                    path="/login"
                    element={
                        <LoginLayout>
                            <LoginPage />
                        </LoginLayout>
                    }
                />
                <Route
                    path="/signin"
                    element={
                        <LoginLayout>
                            <LoginPage />
                        </LoginLayout>
                    }
                />
                {/* Main Layout Routes (Protected) */}
                <Route
                    path="/dashboard"
                    element={
                        <ProtectedRoute>
                            <MainLayout>
                                <Dashboard />
                            </MainLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/properties"
                    element={
                        <ProtectedRoute>
                            <MainLayout>
                                <Properties />
                            </MainLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/portfolio"
                    element={
                        <ProtectedRoute>
                            <MainLayout>
                                <Portfolio />
                            </MainLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/balance-transactions"
                    element={
                        <ProtectedRoute>
                            <MainLayout>
                                <BalanceTransactions />
                            </MainLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/manage-vendors"
                    element={
                        <ProtectedRoute>
                            <MainLayout>
                                <ManageVendors />
                            </MainLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/manage-invoice-categories"
                    element={
                        <ProtectedRoute>
                            <MainLayout>
                                <ManageInvoiceCategories />
                            </MainLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/requests/:type"
                    element={
                        <ProtectedRoute>
                            <MainLayout>
                                <RequestsRouter />
                            </MainLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/parcels"
                    element={
                        <ProtectedRoute>
                            <MainLayout>
                                <Parcels />
                            </MainLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/visitors"
                    element={
                        <ProtectedRoute>
                            <MainLayout>
                                <Visitors />
                            </MainLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/parcels-visitors"
                    element={
                        <ProtectedRoute>
                            <MainLayout>
                                <ParcelsVisitors />
                            </MainLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/management"
                    element={
                        <ProtectedRoute>
                            <MainLayout>
                                <Management />
                            </MainLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/owners"
                    element={
                        <ProtectedRoute>
                            <MainLayout>
                                <Owners />
                            </MainLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/tenants"
                    element={
                        <ProtectedRoute>
                            <MainLayout>
                                <Tenants />
                            </MainLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/announcements"
                    element={
                        <ProtectedRoute>
                            <MainLayout>
                                <Announcements />
                            </MainLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/aichat"
                    element={
                        <ProtectedRoute>
                            <ChatPage />
                        </ProtectedRoute>
                    }
                />
            </Routes>
        </Router>
    );
};

export default AppRoutes;
